<template>
	<div class="card flex justify-content-center relative">
		<!-- <InputSwitch class="!absolute top-[-30px] right-[-5px]" v-model="inlineMode" /> -->
		<div class="card-body w-full">
			<div v-if=" !inlineMode ">
				<EwTextarea ref="inputElement" class="min-w-[300px]" :clearable="false" v-model="referenceString"
					:disabled="props.disabled" rows="5" :placeholder="'Copy-Paste the Bibliographic Citation'" />
				<div class="flex gap-3 mt-3">
					<div class="flex flex-col w-2/3 text-xs">
						<div class="text-gray p-0.5 text-xs">Title</div>
						{{ content.title }}
					</div>
					<div class="flex flex-col text-xs w-1/3">
						<div class="text-gray p-0.5 text-xs">DOI:</div>
						{{ content.nameDOI }}
					</div>
				</div>
				<div class="flex gap-3 w-full justify-between mt-2">
					<div class="flex flex-col text-xs">
						<div class="text-gray p-0.5 text-xs">Journal</div>
						{{ content.journal }}
					</div>
					<div class="flex flex-col text-xs">
						<div class="text-gray p-0.5 text-xs">Volume:</div>
						{{ content.volume }}
					</div>
					<div class="flex flex-col text-xs">
						<div class="text-gray p-0.5 text-xs">ISSUE:</div>
						{{ content.issue }}
					</div>
					<div class="flex flex-col text-xs">
						<div class="text-gray p-0.5 text-xs">Year:</div>
						{{ content.year }}
					</div>
				</div>
			</div>
			<div v-else class="flex gap-2 flex-col ">
				<EwInput ref="inputElement" class="min-w-[300px]" placeholder="Reference Title" :clearable="false"
					v-model="content.title" :disabled="props.disabled">
					<template #prepend>
						<div class="ew-input-group-text">
							Title:
						</div>
					</template>
				</EwInput>
				<div class="flex gap-2 flex-1">
					<div class="flex-1">
						<EwInput ref="inputElement" class="min-w-[300px]" placeholder="Reference Journal name"
							:clearable="false" v-model="content.journal" :disabled="props.disabled">
							<template #prepend>
								<div class="ew-input-group-text">
									Journal:
								</div>
							</template>
						</EwInput>
					</div>
					<div class="flex-1">
						<EwInput ref="inputElement" class="min-w-[300px]" placeholder="Reference year"
							:clearable="false" v-model="content.year" :disabled="props.disabled">
							<template #prepend>
								<div class="ew-input-group-text">
									Year:
								</div>
							</template>
						</EwInput>
					</div>

				</div>
				<div class="flex gap-2 flex-1">
					<div class="flex-1">
						<EwInput ref="inputElement" class="min-w-[300px]" placeholder="DOI Reference Name"
							:clearable="false" v-model="content.nameDOI" :disabled="props.disabled">
							<template #prepend>
								<div class="ew-input-group-text">
									DOI:
								</div>
							</template>
						</EwInput>

					</div>
					<div class="flex-1">
						<EwInput ref="inputElement" class="min-w-[300px]" placeholder="Reference link"
							:clearable="false" v-model="content.linkDOI" :disabled="props.disabled">
							<template #prepend>
								<div class="ew-input-group-text">
									Link:
								</div>
							</template>
						</EwInput>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { EwInput, EwTextarea } from '@arkit/ew-vue-components'
import type { ReferencePostItem } from '@/types';
import { parseReferenceString } from './referenceParserUtil'

const inlineMode = ref( true )

const props = withDefaults( defineProps<{
	disabled?: boolean
}>(), {
	disabled: false,
} )

const content = defineModel<ReferencePostItem>( {
	required: true
} )


const referenceString = ref(content.value.referenceText)
watch( referenceString, ( value ) => {
	content.value = { ...content.value, ...parseReferenceString( value ?? '' ), referenceText: value }
} )
</script>
